import { useLocation } from 'react-router-dom'
import { medicalViewRoutesPath } from '~/constants/route/pathsOfMedicalViews'
import { EMedicalViews, MedicalViewsType } from '~/interfaces'

interface IUseSelectedMedicalView {
  selectedMedicalView: MedicalViewsType
}

export const useSelectedMedicalView = (): IUseSelectedMedicalView => {
  const { pathname } = useLocation()

  const selectedMedicalView = (Object.values(EMedicalViews) as MedicalViewsType[]).find(medicalView => {
    const routeMedicalViewName = medicalViewRoutesPath[medicalView]
    return pathname.includes(routeMedicalViewName)
  })

  return { selectedMedicalView: selectedMedicalView ?? EMedicalViews.NONE }
}
